import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom, { Fragment } from "../../../dist/jsx-render/dom";
import { app } from "../../Frame/App";

export type AvatarProps = {
    width?: string;
    height?: string;
    cssClass?: string;
    id?: string;
    type?: "user" | "role" | "area";
    name: string;
    hasImage?: boolean;
    showImageOnly?: boolean;
}

/**
 * Creates a circle with a user's initials to use as an avatar in list views oder elsewhere.
 * */
export class Avatar extends JSXComponent {
    props: AvatarProps;
    constructor(props: AvatarProps) { super(props); }

    element: SVGElement;

    private getInitials = (): string => {
        if (this.props.name && this.props.name.length > 0) {
            return this.props.name.split(" ").map((w) => {
                return w[0]?.toUpperCase()
            }).concat()?.join('') ?? "";
        }
        else {
            return "";
        }
    }

    private circle: SVGCircleElement;
    private getCircle = () => {
        this.circle = <circle cx="50%" cy="50%" r="18" fill="#C9C9C9" />

        return this.circle;
    }

    createSvgEements = () => {
        let element = <svg viewBox="0 0 40 40" className={`avatar${(this.props.cssClass ? ` ${this.props.cssClass}` : "")}`} />

        if (this.props.id && this.props.type == "user" && this.props.hasImage) {
            let svgImage: SVGImageElement =
                <image width="100%"
                    height="100%"
                    href={app.resolveUrl(`~/api/users/getUserThumbnail/${this.props.id}`)}
                    clip-path="url(#myCircle)" preserveAspectRatio="xMidYMid slice" />;

            element.appendChild(
                <Fragment>
                    <defs>
                        <clipPath id="myCircle">
                            {this.getCircle()}
                        </clipPath>
                    </defs>
                    {this.props.showImageOnly
                        ? []
                        : <text x="50%" y="50%" fontSize="1.2em" fontWeight={500} fill="white" text-anchor="middle" alignment-baseline="middle">{this.getInitials()}</text>}        
                    {svgImage}
                </Fragment>
            );
        } else {
            this.appendCircleWithInitials(element);
        }

        return element;
    }

    appendCircleWithInitials = (element: SVGElement) => {
        element.appendChild(
            <Fragment>
                {this.getCircle()}
                <text x="50%" y="50%" fontSize="1.2em" fontWeight={500} fill="white" text-anchor="middle" alignment-baseline="middle">{this.getInitials()}</text>
            </Fragment>
        );
    }

    render() {
        this.element = this.createSvgEements();
        return this.element;
    }
}